<!-- Start Page Title Area -->
<div class="page-title-area item-term">
    <div class="container">
        <div class="page-title-content">
            <h2>Terms and conditions</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Terms and conditions</li>
            </ul>
        </div>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start project Details Area -->
<div class="projects-details-area ptb-110">
    <div class="container">
        <div class="projects-details">

            <div class="projects-details-desc">
                <h3>Terms and Conditions</h3>
                <p>These terms and conditions represent a legal agreement (“Agreement”) that you (“Customer”) agree to when you use the software products or services provided by Althea Soft LTD (“Company”) in the United Kingdom. By using our software products or services, you agree to be bound by these terms and conditions.</p>

                <h3>License to Use Software</h3>
                <p>Under this Agreement, the Company grants the Customer a personal, non-exclusive, non-transferable license to use the software products or services for its intended purpose. The Customer is not authorized to reproduce, modify, distribute, or sell any part of the software products or services.</p>

                <h3>Legal Compliance</h3>
                <p>The Customer agrees to use the software products or services in compliance with all applicable laws and regulations in the United Kingdom. The Company reserves the right to terminate this Agreement if the Customer breaches any applicable laws or regulations.</p>

                <h3>Intellectual Property Rights</h3>
                <p>The software products or services provided by the Company are the intellectual property of the Company and are protected by copyright, trademark, and other laws in the United Kingdom. The Customer shall not remove any copyright or other proprietary notices from the software products or services.</p>

                <h3>Disclaimer of Warranties</h3>
                <p>The software products or services provided by the Company are provided “as is” and without any warranty, whether express, implied or statutory, including but not limited to warranties of title and non-infringement, and the implied warranties of merchantability and fitness for a particular purpose.</p>
                
                <h3>Limitation of Liability</h3>
                <p>The Company shall not be liable for any direct, indirect, punitive, incidental, special, or consequential damages arising out of or in any way connected with the use or inability to use the software products or services, even if the Company has been advised of the possibility of such damages.</p>
                
                <h3>Termination</h3>
                <p>The Company may terminate this Agreement at any time without notice to the Customer if the Customer breaches any provision of this Agreement. Upon termination, the Customer shall immediately cease all use of the software products or services and destroy all copies of the software products or services in its possession.</p>
                
                <h3>Governing Law and Jurisdiction</h3>
                <p>This Agreement shall be governed by and construed in accordance with the laws of the United Kingdom. Any disputes arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts of the United Kingdom.</p>
                <p>By using our software products or services, the Customer acknowledges that it has read and understood these terms and conditions and agrees to be bound by them.</p>
                
                <blockquote class="wp-block-quote">
                    <p class="mb-0">Experience the future of healthcare with AI-powered tracking and monitoring software.</p>
                </blockquote>
            </div>
        </div>
    </div>
</div>
<!-- End project Details Area -->